export default __webpack_public_path__ + "static/media/how-it-work1-grey.68750862.svg";